import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  title: {
    fontSize: '19px',
    margin: '10px',
    marginLeft: '0px',
    fontWeight: 600,
    color: theme.palette.primary.mainBlue,
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  noteContainer: {
    fontSize: '12.5px',
    marginLeft: '10px',
    lineHeight: '150%',
  },
  referenceBox: {
    display: 'flex',
    alignItems: 'center',
  },
  // Legend swatches for the diff below. They share the import views' diff
  // semantics (added / unchanged / removed), so they use the same tokens.
  referenceNew: {
    borderRadius: '20%',
    marginRight: '5px',
    width: '10px',
    height: '10px',
    backgroundColor: theme.palette.custom.diffAddedText,
  },
  referenceEqual: {
    borderRadius: '20%',
    marginRight: '5px',
    width: '10px',
    height: '10px',
    // Was `primary.mainBlue`, a TEXT token that turns light blue in dark mode.
    backgroundColor: theme.palette.custom.brandButtonBackground,
  },
  referenceDelete: {
    borderRadius: '20%',
    marginRight: '5px',
    width: '10px',
    height: '10px',
    backgroundColor: theme.palette.custom.diffRemovedText,
  },
}));

export default useStyles;
